const header = () => {
    const classes = {
        headerAnimating: 'body--header-animating',
        headerShrinkLogo: 'body--shrink-logo',
        headerRepositionNavElements: 'body--reposition-nav-elements',
    };
    const selectors = {
        header: '.shopify-section-group-header-group .header',
        headerLogo: '[data-cg-header-logo]',
    };
    const header = document.querySelector(selectors.header);
    const headerLogo = document.querySelector(selectors.headerLogo);
    if (header && headerLogo) {
        let isResizing = false;
        headerLogo.addEventListener('transitionstart', (e) => {
            if (e.propertyName === 'height' || e.propertyName === 'width' || e.propertyName === 'transform') {
                isResizing = true;
            }
        });
        headerLogo.addEventListener('transitionend', (e) => {
            if (e.propertyName === 'height' || e.propertyName === 'width' || e.propertyName === 'transform') {
                isResizing = false;
            }
        });
        const events = ['load', 'scroll'];
        events.forEach((event) => {
            window.addEventListener(event, () => {
                if (isResizing)
                    return;
                const scrollAmount = window.scrollY;
                if (scrollAmount >= 50) {
                    document.body.classList.add(classes.headerShrinkLogo);
                }
                else {
                    document.body.classList.remove(classes.headerShrinkLogo);
                }
                if (scrollAmount >= window.outerHeight * 0.4) {
                    document.body.classList.add(classes.headerRepositionNavElements);
                }
                else {
                    document.body.classList.remove(classes.headerRepositionNavElements);
                }
            });
        });
    }
};
export default header;
